import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/static/img/logo.svg'
import _imports_1 from '@/static/img/store/appStore.svg'
import _imports_2 from '@/static/img/store/googlePlay.svg'
import _imports_3 from '@/static/img/store/ruStore.svg'
import _imports_4 from '@/static/img/store/appGallery.svg'


const _hoisted_1 = { class: "mobile-screen" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = ["href"]

import { isMobile } from "@/utils/main";

const downloadLinkDefault = 'https://staff.vitaexpress.ru/';

export default /*@__PURE__*/_defineComponent({
  __name: 'VitaMobileScreen',
  setup(__props) {

const appLinks = {
  ios: 'https://apps.apple.com/ru/app/%D0%BF%D0%BB%D0%B0%D0%BD%D0%B5%D1%82%D0%B0-%D0%B2%D0%B8%D1%82%D0%B0/id1581593643',
  android: 'https://play.google.com/store/apps/details?id=ru.aptekivita.vitastaffandroidnative',
  ruStore: 'https://www.rustore.ru/catalog/app/ru.aptekivita.vitastaffandroidnative',
  appGallery: 'https://appgallery.huawei.com/#/app/C107156587'
};

const isIOS = /iPhone|iPad|iPod/.test(navigator.userAgent);
const isAndroid = /Android/.test(navigator.userAgent);

const downloadApp = () => {
  const downloadLink = isIOS ? appLinks.ios : isAndroid ? appLinks.android : downloadLinkDefault;
  if (isMobile) {
    window.location.href = downloadLink;
  } else {
    window.open(downloadLink, '_blank');
  }
};

return (_ctx: any,_cache: any) => {
  const _component_vita_button = _resolveComponent("vita-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[7] || (_cache[7] = _createElementVNode("div", null, [
      _createElementVNode("img", {
        width: "234",
        height: "77",
        alt: "Вита",
        src: _imports_0
      })
    ], -1)),
    _createElementVNode("div", null, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mobile-screen-text" }, "График сотрудников можно посмотреть в мобильном приложении “Планета Вита”", -1)),
      _createVNode(_component_vita_button, {
        onClick: downloadApp,
        type: "medium",
        "data-qa": "mobile-screen-button-open-app"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Открыть в приложении", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _cache[6] || (_cache[6] = _createElementVNode("div", null, [
        _createElementVNode("div", { class: "mobile-screen-text muted" }, [
          _createTextVNode("Нет приложения? "),
          _createElementVNode("br"),
          _createTextVNode(" Скачивайте на устройство")
        ])
      ], -1)),
      (_unref(isIOS))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("a", {
              href: appLinks.ios,
              target: "_blank",
              "data-qa": "mobile-screen-link-app-store"
            }, [...(_cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "Загрузите в App Store"
              }, null, -1)
            ]))], 8, _hoisted_3)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: appLinks.android,
                  target: "_blank",
                  "data-qa": "mobile-screen-link-google-play"
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    src: _imports_2,
                    alt: "Доступно в Google Play"
                  }, null, -1)
                ]))], 8, _hoisted_5)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: appLinks.ruStore,
                  target: "_blank",
                  "data-qa": "mobile-screen-link-ru-store"
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    src: _imports_3,
                    alt: "Доступно в RuStore"
                  }, null, -1)
                ]))], 8, _hoisted_6)
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: appLinks.appGallery,
                  target: "_blank",
                  "data-qa": "mobile-screen-link-app-gallery"
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    src: _imports_4,
                    alt: "Откройте в AppGallery"
                  }, null, -1)
                ]))], 8, _hoisted_7)
              ])
            ])
          ]))
    ])
  ]))
}
}

})